// extracted by mini-css-extract-plugin
export default {"image":"ResponsiveImage_image__fg75o"};